module.exports = __webpack_public_path__ + "img/MATIC.17d6b63c.png";